var exports = {
  "Ew": "x31de4314--0a4cfd--notification",
  "fh": "x31de4314--0a4cfd--notification-error",
  "VN": "x31de4314--0a4cfd--close",
  "nf": "x31de4314--0a4cfd--link",
};

module.exports = exports;
